import React from 'react';
import Footer from '../components/Footer';

const NoticiasPage = () => {
  const pressArticles = [
    {
      source: 'RoadShow',
      date: '6 de mayo de 2026',
      title: 'La “reinvención” social de Heike Paulmann tras dejar Cencosud',
      summary:
        'La nota aborda el trabajo de Fundación HK en liderazgo femenino, formación técnica en Perú y el nuevo foco social de Heike Paulmann.',
      href: 'https://roadshow.cl/heike-paulmann-reinvencion-social-cencosud/'
    },
    {
      source: 'Reporte Minero',
      date: '31 de marzo de 2026',
      title: 'Programa impulsa liderazgo femenino en minería con foco en formación y empleabilidad',
      summary:
        'La cobertura destaca el programa Somos Bacanas y el trabajo de Fundación HK para formar a jóvenes en contextos vulnerables, combinando habilidades técnicas, liderazgo, autoconfianza y vinculación con empresas para ampliar su empleabilidad.',
      href: 'https://www.reporteminero.cl/noticia/entrevistas/2026/03/programa-somos-bacanas-mujeres-mineria-formacion'
    }
  ];

  const podcastItems = [
    {
      source: 'Duna · Reporte Minero y Energético',
      title: 'Talento, inversión, energía y equidad marcan la agenda del sector',
      summary:
        'Conversación sobre talento femenino, energía, inversión y equidad en el sector, con foco en el trabajo impulsado por Fundación HK.',
      href: 'https://duna.cl/show/reporte-minero-y-energetico/episode/talento-inversion-energia-y-equidad-marcan-la-agenda-del-sector',
      cta: 'Abrir episodio en Duna'
    },
    {
      source: 'Spotify',
      title: 'Escúchalo en Spotify',
      summary:
        'Versión embebida para escuchar el episodio directamente desde la página, sin ocupar tanto espacio vertical.',
      href: 'https://open.spotify.com/episode/68k2OFACxffaoLTAdEJvq4?si=aEEXgQQMSPyFd3gfEsNd7g',
      cta: 'Abrir episodio en Spotify'
    }
  ];

  return (
    <div className="min-h-screen bg-slate-50 pt-24 md:pt-32">
      <section className="px-4 pb-12">
        <div className="mx-auto max-w-6xl">
          <div className="mb-10 text-center">
            <span className="inline-flex items-center rounded-full bg-fhk-orange-100 px-4 py-2 text-sm font-semibold uppercase tracking-[0.2em] text-fhk-orange-600">
              Noticias
            </span>
            <h1 className="mt-5 text-4xl font-bold text-slate-900 md:text-5xl">
              Fundación HK en la prensa
            </h1>
            <p className="mx-auto mt-4 max-w-3xl text-lg leading-relaxed text-slate-600">
              Revisa la cobertura sobre Heike Paulmann y Fundación HK en un formato más ordenado, con acceso rápido a notas y podcasts sin depender de bloques largos con scroll.
            </p>
          </div>

          <div className="rounded-[2rem] border border-slate-200 bg-white p-6 shadow-[0_24px_80px_rgba(15,23,42,0.08)] md:p-8">
            <div className="mb-8 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
              <div className="max-w-3xl">
                <span className="inline-flex items-center rounded-full bg-fhk-orange-100 px-4 py-2 text-sm font-semibold uppercase tracking-[0.2em] text-fhk-orange-600">
                  Prensa Escrita
                </span>
                <h2 className="mt-4 text-3xl font-bold text-slate-900">
                  Noticias destacadas
                </h2>
                <p className="mt-3 text-base leading-relaxed text-slate-600">
                  Accede rápido a cada artículo con un resumen claro, sin bloques extensos incrustados que obliguen a recorrer toda la página.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
              {pressArticles.map((article) => (
                <article
                  key={article.href}
                  className="flex h-full flex-col rounded-[1.5rem] border border-slate-200 bg-slate-50 p-6"
                >
                  <p className="text-sm font-semibold uppercase tracking-[0.18em] text-fhk-cyan-600">
                    {article.source} · {article.date}
                  </p>
                  <h3 className="mt-3 text-2xl font-bold text-slate-900">
                    {article.title}
                  </h3>
                  <p className="mt-4 flex-1 text-base leading-relaxed text-slate-600">
                    {article.summary}
                  </p>
                  <div className="mt-6 flex items-center justify-between gap-3 border-t border-slate-200 pt-5">
                    <span className="text-sm text-slate-500">
                      Lectura externa
                    </span>
                    <a
                      href={article.href}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center justify-center rounded-full bg-fhk-orange-500 px-5 py-3 text-sm font-semibold text-white transition-colors duration-200 hover:bg-fhk-orange-600"
                    >
                      Abrir nota original
                    </a>
                  </div>
                </article>
              ))}
            </div>
          </div>

          <div className="mt-12 rounded-[2rem] border border-slate-200 bg-white p-6 shadow-[0_24px_80px_rgba(15,23,42,0.08)] md:p-8">
            <div className="mb-6 max-w-3xl">
              <span className="inline-flex items-center rounded-full bg-emerald-100 px-4 py-2 text-sm font-semibold uppercase tracking-[0.2em] text-emerald-700">
                Podcasts
              </span>
              <h2 className="mt-4 text-3xl font-bold text-slate-900">
                Escúchalos aquí
              </h2>
              <p className="mt-3 text-base leading-relaxed text-slate-600">
                Los episodios quedan visibles en un bloque más compacto para que puedas decidir rápido dónde escuchar o abrir el contenido completo.
              </p>
            </div>

            <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:items-start">
              <div className="rounded-[1.5rem] border border-slate-200 bg-slate-50 p-5">
                <div className="mb-4">
                  <p className="text-sm font-semibold uppercase tracking-[0.18em] text-fhk-cyan-600">
                    {podcastItems[0].source}
                  </p>
                  <h3 className="mt-2 text-xl font-bold text-slate-900">
                    {podcastItems[0].title}
                  </h3>
                  <p className="mt-3 text-base leading-relaxed text-slate-600">
                    {podcastItems[0].summary}
                  </p>
                </div>

                <div className="rounded-[1.25rem] border border-dashed border-slate-300 bg-white p-6 text-center">
                  <p className="text-sm uppercase tracking-[0.18em] text-slate-500">
                    Reproducción externa
                  </p>
                  <p className="mt-3 text-sm leading-relaxed text-slate-600">
                    Este episodio se abre mejor directamente en Duna para una experiencia más rápida y sin scroll adicional.
                  </p>
                </div>

                <div className="mt-4">
                  <a
                    href={podcastItems[0].href}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center justify-center rounded-full border border-slate-300 px-5 py-3 text-sm font-semibold text-slate-700 transition-colors duration-200 hover:border-slate-400 hover:text-slate-900"
                  >
                    {podcastItems[0].cta}
                  </a>
                </div>
              </div>

              <div className="rounded-[1.5rem] border border-slate-200 bg-slate-50 p-5">
                <div className="mb-4">
                  <p className="text-sm font-semibold uppercase tracking-[0.18em] text-emerald-700">
                    {podcastItems[1].source}
                  </p>
                  <h3 className="mt-2 text-xl font-bold text-slate-900">
                    {podcastItems[1].title}
                  </h3>
                  <p className="mt-3 text-base leading-relaxed text-slate-600">
                    {podcastItems[1].summary}
                  </p>
                </div>

                <div className="overflow-hidden rounded-[1.25rem] border border-slate-200 bg-slate-100 p-3 md:p-4">
                  <iframe
                    title="Podcast de Spotify"
                    src="https://open.spotify.com/embed/episode/68k2OFACxffaoLTAdEJvq4?utm_source=generator"
                    width="100%"
                    height="352"
                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                    loading="lazy"
                    className="rounded-2xl"
                  />
                </div>

                <div className="mt-4">
                  <a
                    href={podcastItems[1].href}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center justify-center rounded-full border border-slate-300 px-5 py-3 text-sm font-semibold text-slate-700 transition-colors duration-200 hover:border-slate-400 hover:text-slate-900"
                  >
                    {podcastItems[1].cta}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default NoticiasPage;